// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SafetyCertificateOutlinedSvg from "@ant-design/icons-svg/es/asn/SafetyCertificateOutlined";
import AntdIcon from '../components/AntdIcon';

var SafetyCertificateOutlined = function SafetyCertificateOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateOutlinedSvg
  }));
};

SafetyCertificateOutlined.displayName = 'SafetyCertificateOutlined';
export default React.forwardRef(SafetyCertificateOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SafetyCertificateOutlined.js
// module id = 1741
// module chunks = 0